document.addEventListener("DOMContentLoaded", function () {

  const targets = [
  "wt-offer-offername",
  "wt-offer-preheading",
  "wt-offer-title",
  "wt-offer-subheading",
  "wt-offer-details",
  "wt-offer-terms",
  "wt-offer-homepage-banner",
  "wt-offer-megamenu",
  "wt-offer-coupon-style",
  "wt-offer-image"
];

  const sourceURL = "/pages/wt-offer/monthly-wt-offer";

  fetch(sourceURL)
    .then(response => response.text())
    .then(html => {

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const source = doc.querySelector(".wt-offer-data");

      if (!source) {
        console.log("WT Offer source not found");
        return;
      }

      targets.forEach(function(id) {

        const destination = document.getElementById(id);
        const content = source.querySelector("#" + id);

        if (destination && content) {
          destination.innerHTML = content.innerHTML;
        }

      });

    })
    .catch(error => {
      console.log("WT Offer loading error:", error);
    });

});